var map = {
	"./cert-E-commerce-hkgcsmeaa.jpg": 402,
	"./cert-customer-hkgcsmeaa.jpg": 403,
	"./cert-finance-hkgcsmeaa.jpg": 405,
	"./cert-fsi-hkgcsmeaa.jpg": 407,
	"./cert-general-staff-a-hkgcsmeaa.jpg": 409,
	"./cert-general-staff-hkgcsmeaa.jpg": 411,
	"./cert-general2024-hkgcsmeaa.jpg": 339,
	"./cert-hr-hkgcsmeaa.jpg": 412,
	"./cert-it-hkgcsmeaa.jpg": 413,
	"./cert-market-hkgcsmeaa.jpg": 414,
	"./cert-ngo-hkgcsmeaa.jpg": 415,
	"./cert-senior-manager-hkgcsmeaa.jpg": 417,
	"./cert-startup-hkgcsmeaa.jpg": 418,
	"./cert-student-hkgcsmeaa.jpg": 420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3375;